import type { FC } from "react";

import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib";
import {
  CALLOUT_BODY_ROW_START_CLASS_MAP,
  CALLOUT_DEFAULTS,
  type TCalloutBodyProps,
} from "./Callout.config";
import { getCalloutCopyColumnClass } from "./Callout.utils";

export const CalloutBody: FC<TCalloutBodyProps> = (
  {
    children,
    asset,
    orientation = CALLOUT_DEFAULTS.orientation,
  },
) => (
  <div
    data-component="CalloutBody"
    className={cn(
      getCalloutCopyColumnClass(asset),
      CALLOUT_BODY_ROW_START_CLASS_MAP[orientation],
    )}
  >
    <TextBody
      className="mb-0"
      isResponsive={false}
      size={2}
      tag="p"
    >
      { children }
    </TextBody>
  </div>
);
